import { PurchaseType } from "src/app/shared/models/app-models";
import { KcRole, OtherPermissionModule } from "./KeycloakRole.model";
import { AbilityField, aor, basicInfo, deadline, dotp, report, sow, tenderValidity, vendorDoc, woc } from "./AppAbility";
import { DocumentMainStatus, DocumentSubStatus } from "../../../shared/models/database-models/DocumentStatus.model";

export class CommandFactory {
    static createFormCommand(permissionRole: string, permissionPurchaseType: PurchaseType): Command {
        switch (permissionRole) {
            case KcRole.PURCHASE_CREATE_OWNER: {
                return new Command((can: any) => {
                    can('create', 'document', [permissionPurchaseType]);
                })
            }
            case KcRole.AOR_READ_ALL: {
                return new Command((can: any) => {
                    can('read', aor, { PurchaseType: { $eq: permissionPurchaseType } });
                })
            }
            case KcRole.AOR_UPDATE_ALL: {
                return new Command((can: any) => {
                })
            }
            case KcRole.WOC_READ_ALL: {
                return new Command((can: any) => {
                    can('read', woc, { PurchaseType: { $eq: permissionPurchaseType } });
                })
            }
            case KcRole.WOC_UPDATE_ALL: {
                return new Command((can: any) => {
                    let conditions: any[] = []
                    if (permissionPurchaseType == PurchaseType.RFQ || permissionPurchaseType == PurchaseType.PCPO || permissionPurchaseType == PurchaseType.CORPORATE_CARD || permissionPurchaseType ==PurchaseType.TENDER) {
                        conditions.push(
                            {
                                PurchaseType: { $eq: permissionPurchaseType },
                                DocumentMainStatus: { $eq: DocumentMainStatus.Draft },
                                DocumentSubStatus: { $eq: DocumentSubStatus.Woc_Draft }
                            },
                            {
                                PurchaseType: { $eq: permissionPurchaseType },
                                DocumentMainStatus: { $eq: DocumentMainStatus.Rejected },
                                DocumentSubStatus: { $eq: DocumentSubStatus.Woc_Rejected }
                            })
                    }
                    else if (permissionPurchaseType == PurchaseType.DC) {
                        conditions.push(
                            {
                                PurchaseType: { $eq: permissionPurchaseType },
                                DocumentMainStatus: { $eq: DocumentMainStatus.Draft },
                                DocumentSubStatus: { $in: [DocumentSubStatus.Woc_Draft, DocumentSubStatus.Woc_Dotp_Draft] }
                            },
                            {
                                PurchaseType: { $eq: permissionPurchaseType },
                                DocumentMainStatus: { $eq: DocumentMainStatus.Rejected },
                                DocumentSubStatus: { $in: [DocumentSubStatus.Woc_Rejected, DocumentSubStatus.Woc_Dotp_Rejected] }
                            })
                    }
                    conditions.forEach(condition => {
                        can('read', woc, condition);
                        can('write', woc, condition);
                        can('update', woc, condition)
                    })

                })
            }
            case KcRole.ATTACHMENT_READ_ALL: {
                return new Command((can: any) => {
                    can('read', vendorDoc, { PurchaseType: { $eq: permissionPurchaseType } });
                })
            }
            case KcRole.ATTACHMENT_UPDATE_ALL: {
                return new Command((can: any) => {
                    let conditions: any[] = []
                    if (permissionPurchaseType == PurchaseType.RFQ || permissionPurchaseType == PurchaseType.PCPO) {
                        conditions.push(
                            {
                                PurchaseType: { $eq: permissionPurchaseType },
                                DocumentMainStatus: { $eq: DocumentMainStatus.Rejected },
                                DocumentSubStatus: { $eq: DocumentSubStatus.Vendor_Document_Rejected }
                            }
                        )
                    }
                    else if (permissionPurchaseType == PurchaseType.TENDER) {
                        conditions.push(
                            {
                                PurchaseType: { $eq: permissionPurchaseType },
                                DocumentMainStatus: { $eq: DocumentMainStatus.Rejected },
                                DocumentSubStatus: { $eq: DocumentSubStatus.Sow_Rejected }
                            },
                            {
                                PurchaseType: { $eq: permissionPurchaseType },
                                DocumentMainStatus: { $eq: DocumentMainStatus.Pending_PR },
                                DocumentSubStatus: { $eq: DocumentSubStatus.Sow_Draft },
                            })

                    }
                    else if (permissionPurchaseType == PurchaseType.DC) {
                        conditions.push(
                            {
                                PurchaseType: { $eq: permissionPurchaseType },
                                DocumentMainStatus: { $eq: DocumentMainStatus.Pending_PR },
                                DocumentSubStatus: { $eq: DocumentSubStatus.Sow_Draft }
                            },
                            {
                                PurchaseType: { $eq: permissionPurchaseType },
                                DocumentMainStatus: { $eq: DocumentMainStatus.Draft },
                                DocumentSubStatus: { $in: [DocumentSubStatus.Aor_Draft, DocumentSubStatus.Woc_Draft, DocumentSubStatus.Woc_Dotp_Draft ] }
                            },
                            {
                                PurchaseType: { $eq: permissionPurchaseType },
                                DocumentMainStatus: { $eq: DocumentMainStatus.Rejected },
                                DocumentSubStatus: { $in: [DocumentSubStatus.Aor_Rejected, DocumentSubStatus.Woc_Rejected, DocumentSubStatus.Woc_Dotp_Rejected, DocumentSubStatus.Sow_Rejected] }
                            },
                            {
                                PurchaseType: { $eq: permissionPurchaseType },
                                DocumentMainStatus: { $eq: DocumentMainStatus.Pending_Approval },
                                DocumentSubStatus: { $eq: DocumentSubStatus.Pending_Woc_Dotp_Approval }
                            })
                    }
                    conditions.forEach(filterConditions => {
                        can('read', vendorDoc, filterConditions);
                        can('write', vendorDoc, filterConditions);
                        can('update', vendorDoc, filterConditions);
                    })
                })
            }
            case KcRole.DEADLINE_READ_ALL: {
                return new Command((can: any) => {
                    can('read', deadline, { PurchaseType: { $eq: permissionPurchaseType } });
                })
            }
            case KcRole.DEADLINE_UPDATE_ALL: {
                return new Command((can: any) => {
                    let conditions: any[] = []
                    if (permissionPurchaseType == PurchaseType.RFQ || permissionPurchaseType == PurchaseType.PCPO) {
                        conditions.push(
                            {
                                PurchaseType: { $eq: permissionPurchaseType },
                                DocumentMainStatus: { $eq: DocumentMainStatus.Pending_Quotation },
                                DocumentSubStatus: { $eq: DocumentSubStatus.Rfq_Sent }
                            })
                    }
                    conditions.forEach(filterConditions => {
                        can('read', deadline, filterConditions);
                        can('write', deadline, filterConditions);
                        // can('update', deadline, filterConditions);
                    })
                })
            }
            case KcRole.BASIC_READ_ALL: {
                return new Command((can: any) => {
                    can('read', basicInfo, { PurchaseType: { $eq: permissionPurchaseType } });
                })
            }
            case KcRole.BASIC_UPDATE_ALL:
                return new Command((can: any) => {
                    /*if (permissionPurchaseType != PurchaseType.TENDER && permissionPurchaseType != PurchaseType.DC) {
                        let filterConditions = {
                            PurchaseType: { $eq: permissionPurchaseType },
                            DocumentMainStatus: { $in: [DocumentMainStatus.Draft, DocumentMainStatus.New] },
                            DocumentSubStatus: { $eq: DocumentSubStatus.New }
                        }
                        can('read', basicInfo, filterConditions);
                        can('update', basicInfo, filterConditions);
                    }*/
                })
            case KcRole.SOW_READ_ALL:
                return new Command((can: any) => {
                    can('read', sow, { PurchaseType: { $eq: permissionPurchaseType } });
                })
            case KcRole.SOW_UPDATE_ALL:
                return new Command((can: any) => {
                    let conditions: any[] = []
                    if (permissionPurchaseType == PurchaseType.TENDER) {
                        conditions.push(
                            {
                                PurchaseType: { $eq: permissionPurchaseType },
                                DocumentMainStatus: { $eq: DocumentMainStatus.Pending_PR },
                                DocumentSubStatus: { $eq: DocumentSubStatus.Sow_Draft }
                            },
                            {
                                PurchaseType: { $eq: permissionPurchaseType },
                                DocumentMainStatus: { $eq: DocumentMainStatus.Rejected },
                                DocumentSubStatus: { $eq: DocumentSubStatus.Sow_Rejected }
                            })

                    }
                    else if (permissionPurchaseType == PurchaseType.DC) {
                        conditions.push(
                            {
                                PurchaseType: { permissionPurchaseType },
                                DocumentMainStatus: { $eq: DocumentMainStatus.Draft },
                                DocumentSubStatus: { $eq: DocumentSubStatus.Woc_Dotp_Draft }
                            },
                            {
                                PurchaseType: { $eq: permissionPurchaseType },
                                DocumentMainStatus: { $eq: DocumentMainStatus.Rejected },
                                DocumentSubStatus: { $eq: DocumentSubStatus.Woc_Dotp_Rejected }
                            })

                    }
                    conditions.forEach(condition => {
                        can('read', sow, condition);
                        can('update', sow, condition);
                        can('update', basicInfo, [AbilityField.Type_Of_Requisition], condition)
                    })
                })
            case KcRole.DOTP_READ_ALL:
                return new Command((can: any) => {
                    can('read', dotp, { PurchaseType: { $eq: permissionPurchaseType } });
                })
            case KcRole.DOTP_UPDATE_ALL:
                return new Command((can: any) => {
                    if (permissionPurchaseType == PurchaseType.TENDER || permissionPurchaseType == PurchaseType.DC) {
                        let conditions: any[] = []
                        conditions.push(
                            {
                                PurchaseType: { $eq: permissionPurchaseType },
                                DocumentMainStatus: { $eq: DocumentMainStatus.Draft },
                                DocumentSubStatus: { $eq: DocumentSubStatus.Woc_Draft }
                            },
                            {
                                PurchaseType: { $eq: permissionPurchaseType },
                                DocumentMainStatus: { $eq: DocumentMainStatus.Rejected },
                                DocumentSubStatus: { $eq: DocumentSubStatus.Woc_Rejected }
                            })
                        conditions.forEach(condition => {
                            can('read', dotp, condition);
                            can('update', dotp, condition);
                        })
                    }
                })
            case KcRole.TVALIDITY_READ_ALL:
                return new Command((can: any) => {
                    can('read', tenderValidity, { PurchaseType: { $eq: permissionPurchaseType } });
                })
            case KcRole.TVALIDITY_UPDATE_ALL:
                return new Command((can: any) => {
                    /*if (permissionPurchaseType == PurchaseType.TENDER) {
                        can('read', tenderValidity, { PurchaseType: { $eq: permissionPurchaseType } });
                        can('update', tenderValidity, { PurchaseType: { $eq: permissionPurchaseType }, DocumentMainStatus: { $eq: DocumentMainStatus.Rejected }, DocumentSubStatus: { $eq: DocumentSubStatus.Sow_Rejected } });
                        can('update', tenderValidity, { PurchaseType: { $eq: permissionPurchaseType }, DocumentMainStatus: { $eq: DocumentMainStatus.Draft }, DocumentSubStatus: { $eq: DocumentSubStatus.Sow_Draft } });
                    }*/
                })
            default:
                return new Command((can: any) => { })
        }
    }

    static createOtherModuleCommand(permissionRole: string, otherPermissionModule: OtherPermissionModule): Command {
        if (otherPermissionModule === OtherPermissionModule.REPORTS) {
            switch (permissionRole) {
                case KcRole.PEREPORT_READ_ALL:
                    return new Command((can: any) => {
                        can('read', report, [AbilityField.Purchase_Executives_Report]);
                    });
                default:
                    return new Command((can: any) => {});
            }
        } else {
            // Placeholder for other modules
            return new Command((can: any) => {});
        }
    }
}
export class Command {
    constructor(private callbackFn: (can: any) => void) { }
    execute(can: any) {
        this.callbackFn(can)
    }
}
export class PermissionInvoker {
    private commands: Command[] = [];
    constructor() { }
    addCommand(command: Command): void {
        this.commands.push(command);
    }

    executeCommands(can: any): void {
        this.commands.forEach(command => {
            command.execute(can);
        });
    }
}